import { DELIMITERS } from "@/constants";

const hasDelimiter = (str: string) => {
  return DELIMITERS.some((delimiter) => str.includes(delimiter));
};

export default hasDelimiter;
